const getMoveTo = ({ shiftX, shiftY, clientX, clientY }: { shiftX: number; shiftY: number; clientX: number; clientY: number }) => ({
    left: clientX - shiftX,
    top: clientY - shiftY,
    shiftX,
    shiftY,
});

export const getDragPosDownPos = (e: MouseEvent, boundingRect: DOMRect) => {
    document.getSelection()?.empty();
    return getMoveTo({
        shiftX: e.clientX - boundingRect.left,
        shiftY: e.clientY - boundingRect.top,
        clientX: e.clientX,
        clientY: e.clientY,
    });
};
export const getDragPosMovePos = (
    e: MouseEvent,
    {
        shiftX,
        shiftY,
    }: {
        shiftX: number;
        shiftY: number;
    },
) => {
    return getMoveTo({
        shiftX,
        shiftY,
        clientX: e.clientX,
        clientY: e.clientY,
    });
};
//
// let startDragDurRight = 0;
// let startDragLeftInitialClientX = 0;
// let startDragLeftDur = 0;
// let startDragLeftShift = 0;
export const getDragRightDurDown = (e: MouseEvent, boundingRect: DOMRect) => {
    return e.clientX - boundingRect.width;
};
//
export const getDragRightDurMove = (e: MouseEvent, cellStepPx: number, startDragDurRight: number, min: number) => {
    document.getSelection()?.empty();
    return Math.max(min, e.clientX - startDragDurRight);
};

export const getDragLeftDurDown = (e: MouseEvent, boundingRect: DOMRect) => {
    document.getSelection()?.empty();
    // 	isDraggingDurLeftStart = true;
    // const boundingRect = leftDragDiv.getBoundingClientRect();
    return {
        startDragLeftInitialClientX: e.clientX,
        startDragLeftShift: e.clientX - boundingRect.left,
        // startDragLeftDur: widthPx, // TODO: this needs to be recorded in the state
    };
    // 	document.addEventListener("mousemove", onMouseMoveDurLeft);
};

export const getDragLeftDurMove = (
    e: MouseEvent,
    {
        startDragLeftInitialClientX,
        cellStepPx,
        startDragLeftDur,
        startDragLeftShift,
        min = 1,
    }: {
        startDragLeftInitialClientX: number;
        cellStepPx: number;
        startDragLeftDur: number;
        startDragLeftShift: number;
        min?: number;
    },
) => {
    const diff = startDragLeftInitialClientX - e.clientX;
    return {
        width: Math.max(min, startDragLeftDur + diff - 1), // TODO: remove this pixel at some point
        left: e.clientX - startDragLeftShift,
    };
};
